/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute } from '@tanstack/react-router'
import ChannelBrowser from '@web/src/features/chat/channel-browser/channel-browser'
import ChatLayout from '@web/src/features/chat/chat-layout/chat-layout'
import { env } from '@web/src/lib/env.client'
import i18n from '@web/src/lib/intl/i18n'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

/**
 * `/chat/channels` is a static segment, which TanStack Router matches ahead of the
 * `$roomId` param route, so the two cannot collide.
 */
export const Route = createFileRoute('/(auth)/(chat-layout)/chat/channels/')({
  component: ChannelBrowserPage,
  head: () => {
    const t = i18n.t.bind(i18n)
    return seo({
      title: `${t('Browse channels')} | ${env.VITE_APP_NAME}`,
      description: t('Browse channels'),
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
      meta: [{ name: 'rating', content: 'adult' }],
    })
  },
})

function ChannelBrowserPage() {
  return (
    <ChatLayout initialTab="channels">
      <div className="min-h-0 flex-1">
        <ChannelBrowser />
      </div>
    </ChatLayout>
  )
}
